import React from 'react'
import Herosection from '../../Herosection'
import { homeObjFour } from './Data'

function SignUp() {
    return (
        <div>
            <Herosection {...homeObjFour}/>
        </div>
    )
}

export default SignUp
